import {useMemo} from "react";

import {USER_ROLES} from "@constants";
import {usePricingDiscountRoleConfig} from "../../../@hooks";


export default function usePriceDiscountTopText() {
	const { userRole, isRetailerUser } = usePricingDiscountRoleConfig()

	const {title, column} = useMemo(() => ({
		[USER_ROLES.STANDARD]: {
			title: "Top 10 Discounts Table",
			column: "Discount \n& Current Price"
		},
		[USER_ROLES.MARKETPLACES]: {
			title: "Top 10 Discounts Table",
			column: "Discount \n& Current Price"
		},
		[USER_ROLES.RETAILER]: {
			title: "Top 10 Price Dispersion Table",
			column: "Price Dispersion \n& Current Price"
		},
	})[userRole], [userRole])

	return {
		title,
		column,
		isRetailerUser
	}
}